<template>
  <div class="flex flex-col gap-24">
    <p class="text-display-2">
      {{ nome }}
    </p>
    <q-card v-if="showGrupo" class="p-24">
      <p class="text-headline-2">
        <span
          class="size-32 inline-grid place-items-center rounded-md mr-4 bg-neutral-100/5 text-neutral-60 !text-headline-3"
        >
          01
        </span>
        {{ t('preInput.message') }}
      </p>

      <span
        class="text-neutral-60 text-headline-3 mt-24 inline-block mb-8"
      >
        {{ t('preInput.options') }}
      </span>
      <div class="flex flex-col gap-8">
        <q-item
          tag="label"
          clickable
          class="p-16 border rounded-md border-neutral-100/10 overflow-hidden"
          :class="{
            'border-primary-pure': fabricanteType === 'especifico',
          }"
        >
          <q-item-section>
            <q-item-label
              class="text-paragraph-2 text-neutral-70"
              :class="{
                'text-primary-pure': fabricanteType === 'especifico',
              }"
            >
              {{ t('preInput.specificBottler') }}
            </q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-radio v-model="fabricanteType" val="especifico" />
          </q-item-section>
        </q-item>
        <q-item
          clickable
          tag="label"
          class="p-16 border rounded-md border-neutral-100/10"
          :class="{
            'border-primary-pure': fabricanteType === 'grupo',
          }"
        >
          <q-item-section>
            <q-item-label
              class="text-paragraph-2 text-neutral-70"
              :class="{
                'text-primary-pure': fabricanteType === 'grupo',
              }"
            >
              {{ t('preInput.bottlerGroup') }}
            </q-item-label>
          </q-item-section>
          <q-item-section side>
            <q-radio v-model="fabricanteType" val="grupo" />
          </q-item-section>
        </q-item>
      </div>
    </q-card>

    <q-card class="p-24">
      <Transition name="fade" :duration="200" mode="out-in">
        <div v-if="fabricanteType === 'especifico'">
          <p class="text-headline-2">
            <span
              class="size-32 inline-grid place-items-center rounded-md mr-4 bg-neutral-100/5 text-neutral-60 !text-headline-3"
            >
              {{ !showGrupo ? '1' : '2' }}
            </span>
            {{ t('preInput.selectBottler') }}
          </p>
          <OSelectPaginated
            :model-value="fabricante"
            api-url="api/fabricantes/"
            option-label="nome"
            option-value="id"
            :adictional-filters="{
              ordering: 'nome',
              categoria_arquivo: categoria?.name,
            }"
            class="bg-white mt-24"
            @update:model-value="$emit('update:fabricante', $event)"
          />
        </div>
        <div v-else-if="fabricanteType === 'grupo'">
          <p class="text-headline-2">
            <span
              class="size-32 inline-grid place-items-center rounded-md mr-4 bg-neutral-100/5 text-neutral-60 !text-headline-3"
            >
              02
            </span>
            {{ t('preInput.createOrSelectGroup') }}
          </p>
          <div class="mt-16 flex items-center gap-24">
            <q-radio
              v-model="grupoExistente"
              val="existente"
              :label="t('preInput.selectExistingGroup')"
            />
            <q-radio
              v-model="grupoExistente"
              val="novo"
              :label="t('preInput.createNewGroup')"
            />
          </div>

          <template v-if="grupoExistente === 'existente'">
            <OSelectPaginated
              :model-value="grupo"
              api-url="api/grupo-template-unificado/"
              option-label="nome"
              option-value="id"
              :adictional-filters="{
                ordering: 'nome',
                categoria_arquivo: categoria?.name,
              }"
              class="bg-white mt-24"
              @update:model-value="$emit('update:grupo', $event)"
            />
          </template>
          <template v-if="grupoExistente === 'novo'">
            <OInput
              v-model="newGroup"
              size="md"
              :label="t('preInput.groupName')"
              class="mt-24"
              :placeholder="t('preInput.enterNewGroupName')"
            />
          </template>
        </div>
      </Transition>
    </q-card>
    <div class="flex justify-end w-full">
      <OButton
        :disable="!disableBtn"
        size="md"
        primary
        :label="t('preInput.continue')"
        class="mt-24"
        @click="onClickContinue"
      />
    </div>
  </div>
</template>

<script setup>
// Você está enviando os dados para um engarrafador específico ou para um grupo de engarrafadores?
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import OButton from 'components/Button/OButton.vue'
import OInput from 'components/Input/OInput.vue'
import OSelectPaginated from 'components/Select/OSelectPaginated.vue'

const { t } = useI18n()

const props = defineProps({
  fabricante: {
    type: [Object, null],
    default: null,
  },
  grupo: {
    type: [Object, null],
    default: null,
  },
  categoria: {
    type: [Object, null],
    default: null,
  },
  nome: {
    type: String,
    default: '',
  },
  showGrupo: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits([
  'update:fabricante',
  'update:grupo',
  'click:continue',
])

const fabricanteType = ref('especifico')
const newGroup = ref('')
const grupoExistente = ref('existente')

const disableBtn = computed(() => {
  return props.fabricante || props.grupo || newGroup.value
})

function onClickContinue() {
  emit('click:continue', {
    type: fabricanteType.value,
    newGroup: newGroup.value,
    grupoExistente: grupoExistente.value,
  })
}

// reseta ao mudar opcoes
watch(
  () => fabricanteType.value,
  (v) => {
    emit('update:fabricante', null)
    emit('update:grupo', null)
    grupoExistente.value = 'existente'
  }
)

watch(
  () => grupoExistente.value,
  (v) => {
    emit('update:grupo', null)
    newGroup.value = ''
  }
)
</script>

<style lang="scss" scoped></style>
